<app-header [translation]="myLanguage"></app-header>

<div class="container">
    <a routerLink="/">{{ myLanguage.back }}</a>

    <div class="alert alert-danger mt-2 mb-2" *ngIf="error !== ''">{{error}}</div>

    <div class="row pt-4" *ngIf="loadedSurveySubmissions !== undefined">
        <div class="col-lg-12 mb-3" *ngFor="let submission of loadedSurveySubmissions">


            <div class="alert alert-warning mb-3" *ngIf="submission.survey?.archived">
                Diese Umfrage ist archiviert und kann nicht mehr beantwortet werden.
            </div>

            <div class="alert alert-warning mb-3" *ngIf="!submission.survey?.visible">
                Diese Umfrage ist nicht sichtbar und kann nicht mehr beantwortet werden.
            </div>


            <article class="mb-3" style="height: auto;">
                <h1 class="post-title">Umfrage: {{ submission.survey?.headline }}</h1>
                <p class="post-body" [innerHTML]="submission.survey?.description"></p>


                <div  *ngFor="let answer of submission.answers">
                    <div *ngIf="!answer.question?.isDependencyQuestion || (answer.question?.isDependencyQuestion && answer.question?.showDependencyQuestion)" class="mt-4" [ngClass]="{'has-validation-error': answer.validationError}">


                        <p class="post-body"><strong>{{ answer.question?.question }}</strong> <strong
                                *ngIf="answer.question?.required" class="text-danger ms-1 fs-7">*</strong></p>
                        <p class="text-muted">{{ answer.question?.helperText }}</p>

                        <div *ngIf="answer.question?.valueType === 'text'">
                            <input type="text" class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'number'">
                            <input type="number" class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'date'">
                            <input type="date" class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'email'">
                            <input type="email" class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'color'">
                            <input type="color" class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value" style="width: 60px; height: 30px;">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'range'">
                            <input type="range" min="0" max="5" class="rating rating--nojs" value="0" step="1"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value">
                        </div>

                        <div *ngIf="answer.question?.valueType === 'radio'">
                            <div class="form-check" *ngFor="let option of answer.question?.valueOptions">

                                <label class="form-check-label"
                                    [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>

                                <input class="form-check-input"
                                    [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                    [id]="'selectBoxId' + answer.question?.uniqueId+option" type="radio"
                                    [checked]="isChecked(option, answer.values)" [value]="option"
                                    (change)="updateCheck(option, answer, 'radio')">
                            </div>
                        </div>

                        <div *ngIf="answer.question?.valueType === 'checkbox'">
                            <div class="form-check" *ngFor="let option of answer.question?.valueOptions">
                                <input class="form-check-input" [checked]="isChecked(option, answer.values)" [value]="option"
                                    [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                    [id]="'selectBoxId' + answer.question?.uniqueId+option" type="radio"
                                    (change)="updateCheck(option, answer, 'radio')">
                                <label class="form-check-label"
                                    [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>
                            </div>
                        </div>

                        <div *ngIf="answer.question?.valueType === 'select'">

                            <div class="form-check" *ngFor="let option of answer.question?.valueOptions">
                                <input class="form-check-input"
                                    [name]="'selectBoxId' + answer.question?.uniqueId+option"
                                    [id]="'selectBoxId' + answer.question?.uniqueId+option" type="checkbox"
                                    [checked]="isChecked(option, answer.values)" [value]="option"
                                    (change)="updateCheck(option, answer, 'checkbox')">
                                <label class="form-check-label"
                                    [for]="'selectBoxId' + answer.question?.uniqueId+option">{{ option }}</label>
                            </div>
                        </div>

                        <div *ngIf="answer.question?.valueType === 'textarea'">
                            <textarea class="form-control"
                                placeholder="Bitte gib hier deine Antwort möglichst präzise ein."
                                [(ngModel)]="answer.value"></textarea>
                        </div>

                        <p class="text-danger mt-2 mb-0" *ngIf="answer.validationError">{{ answer.validationError }}</p>
                    </div>
                </div>

                <button class="btn btn-efs btn-xs btn-primary mt-3" (click)="submitSurvey(submission)">Umfrage
                    abschicken</button>

                <p class="text-danger mt-2 mb-0" *ngIf="submission.hasIssues">Bitte überprüfe deine Eingaben.</p>
            </article>
        </div>
    </div>

</div>

<app-footer [translation]="myLanguage" [userData]="userData"></app-footer>